import { GET_AUDITS, GET_AUDIT_CATEGORIES, GET_AUDIT_ACTIONS } from '../actions/auditsActions';

/**
 * Manejo de la parte del estado correspondiente a auditorías.
 * Permite la actualización del listado de auditorías, la paginación y las categorías.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado
 * @returns El estado con la modificación/acción realizada.
 */
export default function (state = {}, action) {
  switch (action.type) {
    case GET_AUDITS: {
      const audits = action.payload.audits;
      const pagination = action.payload.links;
      return { ...state, audits, pagination };
    }
    case GET_AUDIT_CATEGORIES: {
      return { ...state, categories: action.payload };
    }
    case GET_AUDIT_ACTIONS: {
      return { ...state, actions: action.payload };
    }
    default:
      return state;
  }
}
